import { render } from "./LearningModules.vue?vue&type=template&id=9f6f4f7c"
import script from "./LearningModules.vue?vue&type=script&lang=js"
export * from "./LearningModules.vue?vue&type=script&lang=js"

import "./LearningModules.vue?vue&type=style&index=0&id=9f6f4f7c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__